/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailabilityCalendar = void 0;
var http_1 = require("@wix/ambassador/runtime/http");
var AvailabilityCalendar = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        AvailabilityCalendar: function () {
            return function (headers) {
                var service = {
                    calculateMultiSlotAvailability: function (calculateMultiSlotAvailabilityRequest) {
                        return httpClient.invoke('POST', '/v1/availability/multislot', calculateMultiSlotAvailabilityRequest, headers);
                    },
                    getAvailabilityTimeSlot: function (getAvailabilityTimeSlotRequest) {
                        return httpClient.invoke('POST', '/v1/time-slots/get', getAvailabilityTimeSlotRequest, headers);
                    },
                    getScheduleAvailability: function (getScheduleAvailabilityRequest) {
                        return httpClient.invoke('GET', '/v2/availability/schedule/{schedule_id}', getScheduleAvailabilityRequest, headers);
                    },
                    getSlotAvailability: function (getSlotAvailabilityRequest) {
                        return httpClient.invoke('POST', '/v2/availability/slot', getSlotAvailabilityRequest, headers);
                    },
                    queryAvailability: function (queryAvailabilityRequest) {
                        return httpClient.invoke('POST', '/v1/availability/query', queryAvailabilityRequest, headers);
                    },
                };
                service.calculateMultiSlotAvailability.__http_method = 'POST';
                service.calculateMultiSlotAvailability.__http_url = '/v1/availability/multislot';
                service.getAvailabilityTimeSlot.__http_method = 'POST';
                service.getAvailabilityTimeSlot.__http_url = '/v1/time-slots/get';
                service.getScheduleAvailability.__http_method = 'GET';
                service.getScheduleAvailability.__http_url = '/v2/availability/schedule/{schedule_id}';
                service.getSlotAvailability.__http_method = 'POST';
                service.getSlotAvailability.__http_url = '/v2/availability/slot';
                service.queryAvailability.__http_method = 'POST';
                service.queryAvailability.__http_url = '/v1/availability/query';
                return service;
            };
        },
    };
};
exports.AvailabilityCalendar = AvailabilityCalendar;
exports.AvailabilityCalendar.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map